/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * Kickstart API
 * The Kickstart API description
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import { useCallback } from 'react';

import { useCustomAxiosInstance } from './instance';
import type { ErrorType, BodyType } from './instance';
export interface LoginRequest {
  username: string;
  password: string;
}

export interface LoginResponseOutput {
  access_token: string;
  username: string;
}

export type CustomerListResponseOutputItemsItemCounts = {
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  annotated: number;
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  removed: number;
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  unannotated: number;
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  unknown: number;
};

export type CustomerListResponseOutputItemsItem = {
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  id: number;
  displayName: string;
  counts: CustomerListResponseOutputItemsItemCounts;
};

export interface CustomerListResponseOutput {
  items: CustomerListResponseOutputItemsItem[];
}

export interface OpenShelvesResponseOutput {
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  count: number;
}

export type SubmissionListResponseOutputItemsItemStatus = string | null;

export type SubmissionListResponseOutputItemsItemDepartmentCode = string | null;

export type SubmissionListResponseOutputItemsItemCounts = {
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  annotated: number;
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  removed: number;
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  unannotated: number;
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  unknown: number;
};

export type SubmissionListResponseOutputItemsItem = {
  id: string;
  customerId: number;
  status: SubmissionListResponseOutputItemsItemStatus;
  departmentCode: SubmissionListResponseOutputItemsItemDepartmentCode;
  counts: SubmissionListResponseOutputItemsItemCounts;
};

export interface SubmissionListResponseOutput {
  items: SubmissionListResponseOutputItemsItem[];
}

export type SkuSearchResponseOutputItemsItemImagePath = string | null;

export type SkuSearchResponseOutputItemsItem = {
  skuId: string;
  skuMetadataId: string;
  skuName: string;
  imagePath: SkuSearchResponseOutputItemsItemImagePath;
  images: string[];
};

export interface SkuSearchResponseOutput {
  items: SkuSearchResponseOutputItemsItem[];
}

export type ClusterListResponseOutputItemsItemName = string | null;

export type ClusterListResponseOutputItemsItemCategory = string | null;

export type ClusterListResponseOutputItemsItemImagePath = string | null;

export type ClusterListResponseOutputItemsItemLockedBy = string | null;

export type ClusterListResponseOutputItemsItem = {
  id: string;
  name: ClusterListResponseOutputItemsItemName;
  category: ClusterListResponseOutputItemsItemCategory;
  imagePath: ClusterListResponseOutputItemsItemImagePath;
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  waiting: number;
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  fronts: number;
  markets: string[];
  lockedBy: ClusterListResponseOutputItemsItemLockedBy;
};

export type ClusterListResponseOutputProgress = {
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  clusters: number;
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  done: number;
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  waitingPhotos: number;
};

export interface ClusterListResponseOutput {
  items: ClusterListResponseOutputItemsItem[];
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  total: number;
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  pageSize: number;
  progress: ClusterListResponseOutputProgress;
}

export type ClusterCategoriesResponseOutputItemsItem = {
  name: string;
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  remaining: number;
};

export interface ClusterCategoriesResponseOutput {
  items: ClusterCategoriesResponseOutputItemsItem[];
}

export interface NextClusterBody {
  /** @maxItems 200 */
  category?: string[];
  /** @pattern ^\d+$ */
  excludeId?: string;
}

export type NextClusterResponseOutputId = string | null;

export interface NextClusterResponseOutput {
  id: NextClusterResponseOutputId;
}

export type ClusterDetailResponseOutputName = string | null;

export type ClusterDetailResponseOutputCategory = string | null;

export type ClusterDetailResponseOutputPhotosItemReviewedBy = string | null;

export type ClusterDetailResponseOutputPhotosItemReviewedAt = string | null;

export type ClusterDetailResponseOutputPhotosItemBack = string | null;

export type ClusterDetailResponseOutputPhotosItem = {
  packshotId: string;
  primary: boolean;
  status: string;
  reviewedBy: ClusterDetailResponseOutputPhotosItemReviewedBy;
  reviewedAt: ClusterDetailResponseOutputPhotosItemReviewedAt;
  front: string;
  back: ClusterDetailResponseOutputPhotosItemBack;
};

export interface ClusterDetailResponseOutput {
  id: string;
  name: ClusterDetailResponseOutputName;
  category: ClusterDetailResponseOutputCategory;
  photos: ClusterDetailResponseOutputPhotosItem[];
}

export type ReviewClusterBodyDecisionsItemFrom =
  (typeof ReviewClusterBodyDecisionsItemFrom)[keyof typeof ReviewClusterBodyDecisionsItemFrom];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReviewClusterBodyDecisionsItemFrom = {
  unreviewed: 'unreviewed',
  reviewed: 'reviewed',
  junk: 'junk',
  not_found_sku: 'not_found_sku',
} as const;

export type ReviewClusterBodyDecisionsItemTo =
  (typeof ReviewClusterBodyDecisionsItemTo)[keyof typeof ReviewClusterBodyDecisionsItemTo];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReviewClusterBodyDecisionsItemTo = {
  reviewed: 'reviewed',
  junk: 'junk',
  not_found_sku: 'not_found_sku',
} as const;

export type ReviewClusterBodyDecisionsItem = {
  packshotId: string;
  from: ReviewClusterBodyDecisionsItemFrom;
  to: ReviewClusterBodyDecisionsItemTo;
};

export interface ReviewClusterBody {
  /** @maxItems 1000 */
  decisions: ReviewClusterBodyDecisionsItem[];
}

export interface ReviewClusterResponseOutput {
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  updated: number;
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  skipped: number;
}

export type ClusterClaimResponseOutputHolder = string | null;

export type ClusterClaimResponseOutputSince = string | null;

export interface ClusterClaimResponseOutput {
  mine: boolean;
  holder: ClusterClaimResponseOutputHolder;
  since: ClusterClaimResponseOutputSince;
}

export type SubmissionDetailResponseOutputShelvesItemCounts = {
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  annotated: number;
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  removed: number;
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  unannotated: number;
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  unknown: number;
};

export type SubmissionDetailResponseOutputShelvesItem = {
  id: string;
  imagePath: string;
  counts: SubmissionDetailResponseOutputShelvesItemCounts;
  locked: boolean;
  status: string;
};

export interface SubmissionDetailResponseOutput {
  id: string;
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  customerId: number;
  shelves: SubmissionDetailResponseOutputShelvesItem[];
}

export type WorkspaceDetectionsResponseOutputCounts = {
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  annotated: number;
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  removed: number;
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  unannotated: number;
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  unknown: number;
};

export type WorkspaceDetectionsResponseOutputItemsItemLabel =
  (typeof WorkspaceDetectionsResponseOutputItemsItemLabel)[keyof typeof WorkspaceDetectionsResponseOutputItemsItemLabel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WorkspaceDetectionsResponseOutputItemsItemLabel = {
  ANNOTATED: 'ANNOTATED',
  REMOVED: 'REMOVED',
  UNANNOTATED: 'UNANNOTATED',
  MISSING_SKU: 'MISSING_SKU',
} as const;

export type WorkspaceDetectionsResponseOutputItemsItemShelfId = string | null;

export type WorkspaceDetectionsResponseOutputItemsItemSkuMetadataId =
  | string
  | null;

export type WorkspaceDetectionsResponseOutputItemsItemLabeledByUserId =
  | string
  | null;

export type WorkspaceDetectionsResponseOutputItemsItemSource =
  (typeof WorkspaceDetectionsResponseOutputItemsItemSource)[keyof typeof WorkspaceDetectionsResponseOutputItemsItemSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WorkspaceDetectionsResponseOutputItemsItemSource = {
  MODEL: 'MODEL',
  USER: 'USER',
} as const;

export type WorkspaceDetectionsResponseOutputItemsItem = {
  id: string;
  x1: number;
  y1: number;
  x2: number;
  y2: number;
  confidence: number;
  label: WorkspaceDetectionsResponseOutputItemsItemLabel;
  shelfId: WorkspaceDetectionsResponseOutputItemsItemShelfId;
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  customerId: number;
  skuMetadataId?: WorkspaceDetectionsResponseOutputItemsItemSkuMetadataId;
  labeledByUserId: WorkspaceDetectionsResponseOutputItemsItemLabeledByUserId;
  source: WorkspaceDetectionsResponseOutputItemsItemSource;
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  createdAt: string;
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  updatedAt: string;
};

export interface WorkspaceDetectionsResponseOutput {
  id: string;
  imagePath: string;
  counts: WorkspaceDetectionsResponseOutputCounts;
  locked: boolean;
  status: string;
  items: WorkspaceDetectionsResponseOutputItemsItem[];
}

export type ShelfStatusBodyStatus =
  (typeof ShelfStatusBodyStatus)[keyof typeof ShelfStatusBodyStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShelfStatusBodyStatus = {
  processed: 'processed',
  annotation_in_progress: 'annotation_in_progress',
  annotation_completed: 'annotation_completed',
} as const;

export interface ShelfStatusBody {
  status: ShelfStatusBodyStatus;
}

export interface ShelfStatusResponseOutput {
  id: string;
  status: string;
}

export type PredictionsResponseOutputItemsItemImagePath = string | null;

export type PredictionsResponseOutputItemsItem = {
  skuId: string;
  skuMetadataId: string;
  skuName: string;
  confidence: number;
  imagePath: PredictionsResponseOutputItemsItemImagePath;
};

export interface PredictionsResponseOutput {
  items: PredictionsResponseOutputItemsItem[];
}

export interface CreateDetectionBody {
  /**
   * @maximum 9007199254740991
   */
  customerId: number;
  submissionId: string;
  shelveId: string;
  x1: number;
  y1: number;
  x2: number;
  y2: number;
}

export type DetectionResponseOutputLabel =
  (typeof DetectionResponseOutputLabel)[keyof typeof DetectionResponseOutputLabel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DetectionResponseOutputLabel = {
  ANNOTATED: 'ANNOTATED',
  REMOVED: 'REMOVED',
  UNANNOTATED: 'UNANNOTATED',
  MISSING_SKU: 'MISSING_SKU',
} as const;

export type DetectionResponseOutputShelfId = string | null;

export type DetectionResponseOutputSkuMetadataId = string | null;

export type DetectionResponseOutputLabeledByUserId = string | null;

export type DetectionResponseOutputSource =
  (typeof DetectionResponseOutputSource)[keyof typeof DetectionResponseOutputSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DetectionResponseOutputSource = {
  MODEL: 'MODEL',
  USER: 'USER',
} as const;

export interface DetectionResponseOutput {
  id: string;
  x1: number;
  y1: number;
  x2: number;
  y2: number;
  confidence: number;
  label: DetectionResponseOutputLabel;
  shelfId: DetectionResponseOutputShelfId;
  /**
   * @minimum -9007199254740991
   * @maximum 9007199254740991
   */
  customerId: number;
  skuMetadataId?: DetectionResponseOutputSkuMetadataId;
  labeledByUserId: DetectionResponseOutputLabeledByUserId;
  source: DetectionResponseOutputSource;
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  createdAt: string;
  /** @pattern ^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$ */
  updatedAt: string;
}

export type PatchDetectionBodyLabel =
  (typeof PatchDetectionBodyLabel)[keyof typeof PatchDetectionBodyLabel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchDetectionBodyLabel = {
  ANNOTATED: 'ANNOTATED',
  REMOVED: 'REMOVED',
  UNANNOTATED: 'UNANNOTATED',
  MISSING_SKU: 'MISSING_SKU',
} as const;

export interface PatchDetectionBody {
  detectionId: string;
  label: PatchDetectionBodyLabel;
  skuMetadataId?: string;
  userId: string;
}

export interface GenericSuccessResponseOutput {
  status: boolean;
}

export type CustomerSkusParams = {
  query: string;
};

export type ClustersParams = {
  showFinished?: boolean;
  page?: number;
  category?: string[];
};

export type PredictionsParams = {
  detectionId: string[];
  limit: number;
};

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

export const useAppControllerGetHelloHook = () => {
  const appControllerGetHello = useCustomAxiosInstance<void>();

  return useCallback(
    (signal?: AbortSignal) => {
      return appControllerGetHello({ url: `/api`, method: 'GET', signal });
    },
    [appControllerGetHello]
  );
};

export const getAppControllerGetHelloQueryKey = () => {
  return [`/api`] as const;
};

export const useAppControllerGetHelloQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAppControllerGetHelloHook>>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useAppControllerGetHelloHook>>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAppControllerGetHelloQueryKey();

  const appControllerGetHello = useAppControllerGetHelloHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useAppControllerGetHelloHook>>>
  > = ({ signal }) => appControllerGetHello(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAppControllerGetHelloHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AppControllerGetHelloQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAppControllerGetHelloHook>>>
>;
export type AppControllerGetHelloQueryError = ErrorType<unknown>;

export function useAppControllerGetHello<
  TData = Awaited<ReturnType<ReturnType<typeof useAppControllerGetHelloHook>>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useAppControllerGetHelloHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAppControllerGetHelloHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAppControllerGetHelloHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAppControllerGetHello<
  TData = Awaited<ReturnType<ReturnType<typeof useAppControllerGetHelloHook>>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useAppControllerGetHelloHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAppControllerGetHelloHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAppControllerGetHelloHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAppControllerGetHello<
  TData = Awaited<ReturnType<ReturnType<typeof useAppControllerGetHelloHook>>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useAppControllerGetHelloHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useAppControllerGetHello<
  TData = Awaited<ReturnType<ReturnType<typeof useAppControllerGetHelloHook>>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useAppControllerGetHelloHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useAppControllerGetHelloQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Login
 */
export const useLoginHook = () => {
  const login = useCustomAxiosInstance<LoginResponseOutput>();

  return useCallback(
    (loginRequest: BodyType<LoginRequest>, signal?: AbortSignal) => {
      return login({
        url: `/api/auth/login`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: loginRequest,
        signal,
      });
    },
    [login]
  );
};

export const useLoginMutationOptions = <
  TError = ErrorType<LoginResponseOutput>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useLoginHook>>>,
    TError,
    { data: BodyType<LoginRequest> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useLoginHook>>>,
  TError,
  { data: BodyType<LoginRequest> },
  TContext
> => {
  const mutationKey = ['login'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const login = useLoginHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useLoginHook>>>,
    { data: BodyType<LoginRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return login(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LoginMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useLoginHook>>>
>;
export type LoginMutationBody = BodyType<LoginRequest>;
export type LoginMutationError = ErrorType<LoginResponseOutput>;

/**
 * @summary Login
 */
export const useLogin = <
  TError = ErrorType<LoginResponseOutput>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useLoginHook>>>,
      TError,
      { data: BodyType<LoginRequest> },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useLoginHook>>>,
  TError,
  { data: BodyType<LoginRequest> },
  TContext
> => {
  const mutationOptions = useLoginMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const useAuthControllerProfileHook = () => {
  const authControllerProfile = useCustomAxiosInstance<unknown>();

  return useCallback(
    (signal?: AbortSignal) => {
      return authControllerProfile({
        url: `/api/auth/profile`,
        method: 'GET',
        signal,
      });
    },
    [authControllerProfile]
  );
};

export const getAuthControllerProfileQueryKey = () => {
  return [`/api/auth/profile`] as const;
};

export const useAuthControllerProfileQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>,
  TError = ErrorType<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAuthControllerProfileQueryKey();

  const authControllerProfile = useAuthControllerProfileHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>
  > = ({ signal }) => authControllerProfile(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AuthControllerProfileQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>
>;
export type AuthControllerProfileQueryError = ErrorType<void>;

export function useAuthControllerProfile<
  TData = Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>,
  TError = ErrorType<void>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAuthControllerProfile<
  TData = Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>,
  TError = ErrorType<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAuthControllerProfile<
  TData = Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>,
  TError = ErrorType<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useAuthControllerProfile<
  TData = Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>,
  TError = ErrorType<void>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useAuthControllerProfileHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useAuthControllerProfileQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Initiate Microsoft OAuth authentication
 */
export const useMicrosoftAuthHook = () => {
  const microsoftAuth = useCustomAxiosInstance<void>();

  return useCallback(
    (signal?: AbortSignal) => {
      return microsoftAuth({
        url: `/api/auth/microsoft`,
        method: 'GET',
        signal,
      });
    },
    [microsoftAuth]
  );
};

export const getMicrosoftAuthQueryKey = () => {
  return [`/api/auth/microsoft`] as const;
};

export const useMicrosoftAuthQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useMicrosoftAuthHook>>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useMicrosoftAuthHook>>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMicrosoftAuthQueryKey();

  const microsoftAuth = useMicrosoftAuthHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useMicrosoftAuthHook>>>
  > = ({ signal }) => microsoftAuth(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useMicrosoftAuthHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type MicrosoftAuthQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useMicrosoftAuthHook>>>
>;
export type MicrosoftAuthQueryError = ErrorType<unknown>;

export function useMicrosoftAuth<
  TData = Awaited<ReturnType<ReturnType<typeof useMicrosoftAuthHook>>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useMicrosoftAuthHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useMicrosoftAuthHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useMicrosoftAuthHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useMicrosoftAuth<
  TData = Awaited<ReturnType<ReturnType<typeof useMicrosoftAuthHook>>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useMicrosoftAuthHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useMicrosoftAuthHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useMicrosoftAuthHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useMicrosoftAuth<
  TData = Awaited<ReturnType<ReturnType<typeof useMicrosoftAuthHook>>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useMicrosoftAuthHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Initiate Microsoft OAuth authentication
 */

export function useMicrosoftAuth<
  TData = Awaited<ReturnType<ReturnType<typeof useMicrosoftAuthHook>>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useMicrosoftAuthHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useMicrosoftAuthQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Handle Microsoft OAuth callback
 */
export const useMicrosoftCallbackHook = () => {
  const microsoftCallback = useCustomAxiosInstance<void>();

  return useCallback(
    (signal?: AbortSignal) => {
      return microsoftCallback({
        url: `/api/auth/microsoft/callback`,
        method: 'GET',
        signal,
      });
    },
    [microsoftCallback]
  );
};

export const getMicrosoftCallbackQueryKey = () => {
  return [`/api/auth/microsoft/callback`] as const;
};

export const useMicrosoftCallbackQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useMicrosoftCallbackHook>>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useMicrosoftCallbackHook>>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMicrosoftCallbackQueryKey();

  const microsoftCallback = useMicrosoftCallbackHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useMicrosoftCallbackHook>>>
  > = ({ signal }) => microsoftCallback(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useMicrosoftCallbackHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type MicrosoftCallbackQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useMicrosoftCallbackHook>>>
>;
export type MicrosoftCallbackQueryError = ErrorType<unknown>;

export function useMicrosoftCallback<
  TData = Awaited<ReturnType<ReturnType<typeof useMicrosoftCallbackHook>>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useMicrosoftCallbackHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useMicrosoftCallbackHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useMicrosoftCallbackHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useMicrosoftCallback<
  TData = Awaited<ReturnType<ReturnType<typeof useMicrosoftCallbackHook>>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useMicrosoftCallbackHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useMicrosoftCallbackHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useMicrosoftCallbackHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useMicrosoftCallback<
  TData = Awaited<ReturnType<ReturnType<typeof useMicrosoftCallbackHook>>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useMicrosoftCallbackHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Handle Microsoft OAuth callback
 */

export function useMicrosoftCallback<
  TData = Awaited<ReturnType<ReturnType<typeof useMicrosoftCallbackHook>>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useMicrosoftCallbackHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useMicrosoftCallbackQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List all customers
 */
export const useCustomersHook = () => {
  const customers = useCustomAxiosInstance<CustomerListResponseOutput>();

  return useCallback(
    (signal?: AbortSignal) => {
      return customers({ url: `/api/customers`, method: 'GET', signal });
    },
    [customers]
  );
};

export const getCustomersQueryKey = () => {
  return [`/api/customers`] as const;
};

export const useCustomersQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useCustomersHook>>>,
  TError = ErrorType<void | CustomerListResponseOutput>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useCustomersHook>>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCustomersQueryKey();

  const customers = useCustomersHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useCustomersHook>>>
  > = ({ signal }) => customers(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useCustomersHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CustomersQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCustomersHook>>>
>;
export type CustomersQueryError = ErrorType<void | CustomerListResponseOutput>;

export function useCustomers<
  TData = Awaited<ReturnType<ReturnType<typeof useCustomersHook>>>,
  TError = ErrorType<void | CustomerListResponseOutput>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useCustomersHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useCustomersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useCustomersHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCustomers<
  TData = Awaited<ReturnType<ReturnType<typeof useCustomersHook>>>,
  TError = ErrorType<void | CustomerListResponseOutput>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useCustomersHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useCustomersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useCustomersHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCustomers<
  TData = Awaited<ReturnType<ReturnType<typeof useCustomersHook>>>,
  TError = ErrorType<void | CustomerListResponseOutput>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useCustomersHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List all customers
 */

export function useCustomers<
  TData = Awaited<ReturnType<ReturnType<typeof useCustomersHook>>>,
  TError = ErrorType<void | CustomerListResponseOutput>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useCustomersHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useCustomersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Count the shelves still to annotate
 */
export const useOpenShelvesHook = () => {
  const openShelves = useCustomAxiosInstance<OpenShelvesResponseOutput>();

  return useCallback(
    (signal?: AbortSignal) => {
      return openShelves({
        url: `/api/customers/open-shelves`,
        method: 'GET',
        signal,
      });
    },
    [openShelves]
  );
};

export const getOpenShelvesQueryKey = () => {
  return [`/api/customers/open-shelves`] as const;
};

export const useOpenShelvesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useOpenShelvesHook>>>,
  TError = ErrorType<void | OpenShelvesResponseOutput>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useOpenShelvesHook>>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getOpenShelvesQueryKey();

  const openShelves = useOpenShelvesHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useOpenShelvesHook>>>
  > = ({ signal }) => openShelves(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useOpenShelvesHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type OpenShelvesQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useOpenShelvesHook>>>
>;
export type OpenShelvesQueryError = ErrorType<void | OpenShelvesResponseOutput>;

export function useOpenShelves<
  TData = Awaited<ReturnType<ReturnType<typeof useOpenShelvesHook>>>,
  TError = ErrorType<void | OpenShelvesResponseOutput>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useOpenShelvesHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useOpenShelvesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useOpenShelvesHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useOpenShelves<
  TData = Awaited<ReturnType<ReturnType<typeof useOpenShelvesHook>>>,
  TError = ErrorType<void | OpenShelvesResponseOutput>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useOpenShelvesHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useOpenShelvesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useOpenShelvesHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useOpenShelves<
  TData = Awaited<ReturnType<ReturnType<typeof useOpenShelvesHook>>>,
  TError = ErrorType<void | OpenShelvesResponseOutput>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useOpenShelvesHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Count the shelves still to annotate
 */

export function useOpenShelves<
  TData = Awaited<ReturnType<ReturnType<typeof useOpenShelvesHook>>>,
  TError = ErrorType<void | OpenShelvesResponseOutput>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useOpenShelvesHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useOpenShelvesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List submissions associated with a customer
 */
export const useCustomerSubmissionsHook = () => {
  const customerSubmissions =
    useCustomAxiosInstance<SubmissionListResponseOutput>();

  return useCallback(
    (customerId: number, signal?: AbortSignal) => {
      return customerSubmissions({
        url: `/api/customers/${customerId}/submissions`,
        method: 'GET',
        signal,
      });
    },
    [customerSubmissions]
  );
};

export const getCustomerSubmissionsQueryKey = (customerId: number) => {
  return [`/api/customers/${customerId}/submissions`] as const;
};

export const useCustomerSubmissionsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useCustomerSubmissionsHook>>>,
  TError = ErrorType<void | SubmissionListResponseOutput>,
>(
  customerId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useCustomerSubmissionsHook>>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCustomerSubmissionsQueryKey(customerId);

  const customerSubmissions = useCustomerSubmissionsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useCustomerSubmissionsHook>>>
  > = ({ signal }) => customerSubmissions(customerId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!customerId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useCustomerSubmissionsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CustomerSubmissionsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCustomerSubmissionsHook>>>
>;
export type CustomerSubmissionsQueryError =
  ErrorType<void | SubmissionListResponseOutput>;

export function useCustomerSubmissions<
  TData = Awaited<ReturnType<ReturnType<typeof useCustomerSubmissionsHook>>>,
  TError = ErrorType<void | SubmissionListResponseOutput>,
>(
  customerId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useCustomerSubmissionsHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useCustomerSubmissionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useCustomerSubmissionsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCustomerSubmissions<
  TData = Awaited<ReturnType<ReturnType<typeof useCustomerSubmissionsHook>>>,
  TError = ErrorType<void | SubmissionListResponseOutput>,
>(
  customerId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useCustomerSubmissionsHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useCustomerSubmissionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useCustomerSubmissionsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCustomerSubmissions<
  TData = Awaited<ReturnType<ReturnType<typeof useCustomerSubmissionsHook>>>,
  TError = ErrorType<void | SubmissionListResponseOutput>,
>(
  customerId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useCustomerSubmissionsHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List submissions associated with a customer
 */

export function useCustomerSubmissions<
  TData = Awaited<ReturnType<ReturnType<typeof useCustomerSubmissionsHook>>>,
  TError = ErrorType<void | SubmissionListResponseOutput>,
>(
  customerId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useCustomerSubmissionsHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useCustomerSubmissionsQueryOptions(customerId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Search for SKUs associated with a customer
 */
export const useCustomerSkusHook = () => {
  const customerSkus = useCustomAxiosInstance<SkuSearchResponseOutput>();

  return useCallback(
    (customerId: number, params: CustomerSkusParams, signal?: AbortSignal) => {
      return customerSkus({
        url: `/api/customers/${customerId}/sku`,
        method: 'GET',
        params,
        signal,
      });
    },
    [customerSkus]
  );
};

export const getCustomerSkusQueryKey = (
  customerId: number,
  params: CustomerSkusParams
) => {
  return [
    `/api/customers/${customerId}/sku`,
    ...(params ? [params] : []),
  ] as const;
};

export const useCustomerSkusQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useCustomerSkusHook>>>,
  TError = ErrorType<void | SkuSearchResponseOutput>,
>(
  customerId: number,
  params: CustomerSkusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useCustomerSkusHook>>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCustomerSkusQueryKey(customerId, params);

  const customerSkus = useCustomerSkusHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useCustomerSkusHook>>>
  > = ({ signal }) => customerSkus(customerId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!customerId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useCustomerSkusHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CustomerSkusQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCustomerSkusHook>>>
>;
export type CustomerSkusQueryError = ErrorType<void | SkuSearchResponseOutput>;

export function useCustomerSkus<
  TData = Awaited<ReturnType<ReturnType<typeof useCustomerSkusHook>>>,
  TError = ErrorType<void | SkuSearchResponseOutput>,
>(
  customerId: number,
  params: CustomerSkusParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useCustomerSkusHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useCustomerSkusHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useCustomerSkusHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCustomerSkus<
  TData = Awaited<ReturnType<ReturnType<typeof useCustomerSkusHook>>>,
  TError = ErrorType<void | SkuSearchResponseOutput>,
>(
  customerId: number,
  params: CustomerSkusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useCustomerSkusHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useCustomerSkusHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useCustomerSkusHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCustomerSkus<
  TData = Awaited<ReturnType<ReturnType<typeof useCustomerSkusHook>>>,
  TError = ErrorType<void | SkuSearchResponseOutput>,
>(
  customerId: number,
  params: CustomerSkusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useCustomerSkusHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Search for SKUs associated with a customer
 */

export function useCustomerSkus<
  TData = Awaited<ReturnType<ReturnType<typeof useCustomerSkusHook>>>,
  TError = ErrorType<void | SkuSearchResponseOutput>,
>(
  customerId: number,
  params: CustomerSkusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useCustomerSkusHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useCustomerSkusQueryOptions(customerId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List packshot clusters, most waiting photos first
 */
export const useClustersHook = () => {
  const clusters = useCustomAxiosInstance<ClusterListResponseOutput>();

  return useCallback(
    (params?: ClustersParams, signal?: AbortSignal) => {
      return clusters({ url: `/api/clusters`, method: 'GET', params, signal });
    },
    [clusters]
  );
};

export const getClustersQueryKey = (params?: ClustersParams) => {
  return [`/api/clusters`, ...(params ? [params] : [])] as const;
};

export const useClustersQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useClustersHook>>>,
  TError = ErrorType<void | ClusterListResponseOutput>,
>(
  params?: ClustersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useClustersHook>>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getClustersQueryKey(params);

  const clusters = useClustersHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useClustersHook>>>
  > = ({ signal }) => clusters(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useClustersHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ClustersQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useClustersHook>>>
>;
export type ClustersQueryError = ErrorType<void | ClusterListResponseOutput>;

export function useClusters<
  TData = Awaited<ReturnType<ReturnType<typeof useClustersHook>>>,
  TError = ErrorType<void | ClusterListResponseOutput>,
>(
  params: undefined | ClustersParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useClustersHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useClustersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useClustersHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useClusters<
  TData = Awaited<ReturnType<ReturnType<typeof useClustersHook>>>,
  TError = ErrorType<void | ClusterListResponseOutput>,
>(
  params?: ClustersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useClustersHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useClustersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useClustersHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useClusters<
  TData = Awaited<ReturnType<ReturnType<typeof useClustersHook>>>,
  TError = ErrorType<void | ClusterListResponseOutput>,
>(
  params?: ClustersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useClustersHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List packshot clusters, most waiting photos first
 */

export function useClusters<
  TData = Awaited<ReturnType<ReturnType<typeof useClustersHook>>>,
  TError = ErrorType<void | ClusterListResponseOutput>,
>(
  params?: ClustersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useClustersHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useClustersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List the categories clusters can be filtered on
 */
export const useClusterCategoriesHook = () => {
  const clusterCategories =
    useCustomAxiosInstance<ClusterCategoriesResponseOutput>();

  return useCallback(
    (signal?: AbortSignal) => {
      return clusterCategories({
        url: `/api/clusters/categories`,
        method: 'GET',
        signal,
      });
    },
    [clusterCategories]
  );
};

export const getClusterCategoriesQueryKey = () => {
  return [`/api/clusters/categories`] as const;
};

export const useClusterCategoriesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useClusterCategoriesHook>>>,
  TError = ErrorType<void | ClusterCategoriesResponseOutput>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useClusterCategoriesHook>>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getClusterCategoriesQueryKey();

  const clusterCategories = useClusterCategoriesHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useClusterCategoriesHook>>>
  > = ({ signal }) => clusterCategories(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useClusterCategoriesHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ClusterCategoriesQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useClusterCategoriesHook>>>
>;
export type ClusterCategoriesQueryError =
  ErrorType<void | ClusterCategoriesResponseOutput>;

export function useClusterCategories<
  TData = Awaited<ReturnType<ReturnType<typeof useClusterCategoriesHook>>>,
  TError = ErrorType<void | ClusterCategoriesResponseOutput>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useClusterCategoriesHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useClusterCategoriesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useClusterCategoriesHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useClusterCategories<
  TData = Awaited<ReturnType<ReturnType<typeof useClusterCategoriesHook>>>,
  TError = ErrorType<void | ClusterCategoriesResponseOutput>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useClusterCategoriesHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useClusterCategoriesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useClusterCategoriesHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useClusterCategories<
  TData = Awaited<ReturnType<ReturnType<typeof useClusterCategoriesHook>>>,
  TError = ErrorType<void | ClusterCategoriesResponseOutput>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useClusterCategoriesHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List the categories clusters can be filtered on
 */

export function useClusterCategories<
  TData = Awaited<ReturnType<ReturnType<typeof useClusterCategoriesHook>>>,
  TError = ErrorType<void | ClusterCategoriesResponseOutput>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useClusterCategoriesHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useClusterCategoriesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Claim the next free cluster that still waits for review
 */
export const useNextClusterHook = () => {
  const nextCluster = useCustomAxiosInstance<NextClusterResponseOutput>();

  return useCallback(
    (nextClusterBody: BodyType<NextClusterBody>, signal?: AbortSignal) => {
      return nextCluster({
        url: `/api/clusters/next`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: nextClusterBody,
        signal,
      });
    },
    [nextCluster]
  );
};

export const useNextClusterMutationOptions = <
  TError = ErrorType<void | NextClusterResponseOutput>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useNextClusterHook>>>,
    TError,
    { data: BodyType<NextClusterBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useNextClusterHook>>>,
  TError,
  { data: BodyType<NextClusterBody> },
  TContext
> => {
  const mutationKey = ['nextCluster'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const nextCluster = useNextClusterHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useNextClusterHook>>>,
    { data: BodyType<NextClusterBody> }
  > = (props) => {
    const { data } = props ?? {};

    return nextCluster(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type NextClusterMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useNextClusterHook>>>
>;
export type NextClusterMutationBody = BodyType<NextClusterBody>;
export type NextClusterMutationError =
  ErrorType<void | NextClusterResponseOutput>;

/**
 * @summary Claim the next free cluster that still waits for review
 */
export const useNextCluster = <
  TError = ErrorType<void | NextClusterResponseOutput>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useNextClusterHook>>>,
      TError,
      { data: BodyType<NextClusterBody> },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useNextClusterHook>>>,
  TError,
  { data: BodyType<NextClusterBody> },
  TContext
> => {
  const mutationOptions = useNextClusterMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get a cluster with its photos
 */
export const useClusterHook = () => {
  const cluster = useCustomAxiosInstance<ClusterDetailResponseOutput>();

  return useCallback(
    (clusterId: number, signal?: AbortSignal) => {
      return cluster({
        url: `/api/clusters/${clusterId}`,
        method: 'GET',
        signal,
      });
    },
    [cluster]
  );
};

export const getClusterQueryKey = (clusterId: number) => {
  return [`/api/clusters/${clusterId}`] as const;
};

export const useClusterQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useClusterHook>>>,
  TError = ErrorType<void | ClusterDetailResponseOutput>,
>(
  clusterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useClusterHook>>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getClusterQueryKey(clusterId);

  const cluster = useClusterHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useClusterHook>>>
  > = ({ signal }) => cluster(clusterId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!clusterId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useClusterHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ClusterQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useClusterHook>>>
>;
export type ClusterQueryError = ErrorType<void | ClusterDetailResponseOutput>;

export function useCluster<
  TData = Awaited<ReturnType<ReturnType<typeof useClusterHook>>>,
  TError = ErrorType<void | ClusterDetailResponseOutput>,
>(
  clusterId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useClusterHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useClusterHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useClusterHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCluster<
  TData = Awaited<ReturnType<ReturnType<typeof useClusterHook>>>,
  TError = ErrorType<void | ClusterDetailResponseOutput>,
>(
  clusterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useClusterHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useClusterHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useClusterHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useCluster<
  TData = Awaited<ReturnType<ReturnType<typeof useClusterHook>>>,
  TError = ErrorType<void | ClusterDetailResponseOutput>,
>(
  clusterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useClusterHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a cluster with its photos
 */

export function useCluster<
  TData = Awaited<ReturnType<ReturnType<typeof useClusterHook>>>,
  TError = ErrorType<void | ClusterDetailResponseOutput>,
>(
  clusterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useClusterHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useClusterQueryOptions(clusterId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Save junk / wrong SKU marks; approve the rest
 */
export const useReviewClusterHook = () => {
  const reviewCluster = useCustomAxiosInstance<ReviewClusterResponseOutput>();

  return useCallback(
    (
      clusterId: number,
      reviewClusterBody: BodyType<ReviewClusterBody>,
      signal?: AbortSignal
    ) => {
      return reviewCluster({
        url: `/api/clusters/${clusterId}/review`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: reviewClusterBody,
        signal,
      });
    },
    [reviewCluster]
  );
};

export const useReviewClusterMutationOptions = <
  TError = ErrorType<void | ReviewClusterResponseOutput>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useReviewClusterHook>>>,
    TError,
    { clusterId: number; data: BodyType<ReviewClusterBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useReviewClusterHook>>>,
  TError,
  { clusterId: number; data: BodyType<ReviewClusterBody> },
  TContext
> => {
  const mutationKey = ['reviewCluster'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const reviewCluster = useReviewClusterHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useReviewClusterHook>>>,
    { clusterId: number; data: BodyType<ReviewClusterBody> }
  > = (props) => {
    const { clusterId, data } = props ?? {};

    return reviewCluster(clusterId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReviewClusterMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useReviewClusterHook>>>
>;
export type ReviewClusterMutationBody = BodyType<ReviewClusterBody>;
export type ReviewClusterMutationError =
  ErrorType<void | ReviewClusterResponseOutput>;

/**
 * @summary Save junk / wrong SKU marks; approve the rest
 */
export const useReviewCluster = <
  TError = ErrorType<void | ReviewClusterResponseOutput>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useReviewClusterHook>>>,
      TError,
      { clusterId: number; data: BodyType<ReviewClusterBody> },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useReviewClusterHook>>>,
  TError,
  { clusterId: number; data: BodyType<ReviewClusterBody> },
  TContext
> => {
  const mutationOptions = useReviewClusterMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Lock a cluster to the caller, or renew their lock
 */
export const useClaimClusterHook = () => {
  const claimCluster = useCustomAxiosInstance<ClusterClaimResponseOutput>();

  return useCallback(
    (clusterId: number, signal?: AbortSignal) => {
      return claimCluster({
        url: `/api/clusters/${clusterId}/claim`,
        method: 'POST',
        signal,
      });
    },
    [claimCluster]
  );
};

export const useClaimClusterMutationOptions = <
  TError = ErrorType<void | ClusterClaimResponseOutput>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useClaimClusterHook>>>,
    TError,
    { clusterId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useClaimClusterHook>>>,
  TError,
  { clusterId: number },
  TContext
> => {
  const mutationKey = ['claimCluster'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const claimCluster = useClaimClusterHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useClaimClusterHook>>>,
    { clusterId: number }
  > = (props) => {
    const { clusterId } = props ?? {};

    return claimCluster(clusterId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ClaimClusterMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useClaimClusterHook>>>
>;

export type ClaimClusterMutationError =
  ErrorType<void | ClusterClaimResponseOutput>;

/**
 * @summary Lock a cluster to the caller, or renew their lock
 */
export const useClaimCluster = <
  TError = ErrorType<void | ClusterClaimResponseOutput>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useClaimClusterHook>>>,
      TError,
      { clusterId: number },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useClaimClusterHook>>>,
  TError,
  { clusterId: number },
  TContext
> => {
  const mutationOptions = useClaimClusterMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Give up the caller's lock on a cluster
 */
export const useReleaseClusterHook = () => {
  const releaseCluster = useCustomAxiosInstance<unknown>();

  return useCallback(
    (clusterId: number) => {
      return releaseCluster({
        url: `/api/clusters/${clusterId}/claim`,
        method: 'DELETE',
      });
    },
    [releaseCluster]
  );
};

export const useReleaseClusterMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useReleaseClusterHook>>>,
    TError,
    { clusterId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useReleaseClusterHook>>>,
  TError,
  { clusterId: number },
  TContext
> => {
  const mutationKey = ['releaseCluster'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const releaseCluster = useReleaseClusterHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useReleaseClusterHook>>>,
    { clusterId: number }
  > = (props) => {
    const { clusterId } = props ?? {};

    return releaseCluster(clusterId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReleaseClusterMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useReleaseClusterHook>>>
>;

export type ReleaseClusterMutationError = ErrorType<void>;

/**
 * @summary Give up the caller's lock on a cluster
 */
export const useReleaseCluster = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useReleaseClusterHook>>>,
      TError,
      { clusterId: number },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useReleaseClusterHook>>>,
  TError,
  { clusterId: number },
  TContext
> => {
  const mutationOptions = useReleaseClusterMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const useSubmissionHook = () => {
  const submission = useCustomAxiosInstance<SubmissionDetailResponseOutput>();

  return useCallback(
    (submissionId: string, signal?: AbortSignal) => {
      return submission({
        url: `/api/submissions/${submissionId}`,
        method: 'GET',
        signal,
      });
    },
    [submission]
  );
};

export const getSubmissionQueryKey = (submissionId: string) => {
  return [`/api/submissions/${submissionId}`] as const;
};

export const useSubmissionQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useSubmissionHook>>>,
  TError = ErrorType<void | SubmissionDetailResponseOutput>,
>(
  submissionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useSubmissionHook>>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSubmissionQueryKey(submissionId);

  const submission = useSubmissionHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useSubmissionHook>>>
  > = ({ signal }) => submission(submissionId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!submissionId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useSubmissionHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SubmissionQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useSubmissionHook>>>
>;
export type SubmissionQueryError =
  ErrorType<void | SubmissionDetailResponseOutput>;

export function useSubmission<
  TData = Awaited<ReturnType<ReturnType<typeof useSubmissionHook>>>,
  TError = ErrorType<void | SubmissionDetailResponseOutput>,
>(
  submissionId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useSubmissionHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useSubmissionHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useSubmissionHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSubmission<
  TData = Awaited<ReturnType<ReturnType<typeof useSubmissionHook>>>,
  TError = ErrorType<void | SubmissionDetailResponseOutput>,
>(
  submissionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useSubmissionHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useSubmissionHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useSubmissionHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSubmission<
  TData = Awaited<ReturnType<ReturnType<typeof useSubmissionHook>>>,
  TError = ErrorType<void | SubmissionDetailResponseOutput>,
>(
  submissionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useSubmissionHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useSubmission<
  TData = Awaited<ReturnType<ReturnType<typeof useSubmissionHook>>>,
  TError = ErrorType<void | SubmissionDetailResponseOutput>,
>(
  submissionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useSubmissionHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useSubmissionQueryOptions(submissionId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const useShelfDetectionsHook = () => {
  const shelfDetections =
    useCustomAxiosInstance<WorkspaceDetectionsResponseOutput>();

  return useCallback(
    (submissionId: string, shelveId: string, signal?: AbortSignal) => {
      return shelfDetections({
        url: `/api/submissions/${submissionId}/shelves/${shelveId}`,
        method: 'GET',
        signal,
      });
    },
    [shelfDetections]
  );
};

export const getShelfDetectionsQueryKey = (
  submissionId: string,
  shelveId: string
) => {
  return [`/api/submissions/${submissionId}/shelves/${shelveId}`] as const;
};

export const useShelfDetectionsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useShelfDetectionsHook>>>,
  TError = ErrorType<void | WorkspaceDetectionsResponseOutput>,
>(
  submissionId: string,
  shelveId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useShelfDetectionsHook>>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getShelfDetectionsQueryKey(submissionId, shelveId);

  const shelfDetections = useShelfDetectionsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useShelfDetectionsHook>>>
  > = ({ signal }) => shelfDetections(submissionId, shelveId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(submissionId && shelveId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useShelfDetectionsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ShelfDetectionsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useShelfDetectionsHook>>>
>;
export type ShelfDetectionsQueryError =
  ErrorType<void | WorkspaceDetectionsResponseOutput>;

export function useShelfDetections<
  TData = Awaited<ReturnType<ReturnType<typeof useShelfDetectionsHook>>>,
  TError = ErrorType<void | WorkspaceDetectionsResponseOutput>,
>(
  submissionId: string,
  shelveId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useShelfDetectionsHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useShelfDetectionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useShelfDetectionsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useShelfDetections<
  TData = Awaited<ReturnType<ReturnType<typeof useShelfDetectionsHook>>>,
  TError = ErrorType<void | WorkspaceDetectionsResponseOutput>,
>(
  submissionId: string,
  shelveId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useShelfDetectionsHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useShelfDetectionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useShelfDetectionsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useShelfDetections<
  TData = Awaited<ReturnType<ReturnType<typeof useShelfDetectionsHook>>>,
  TError = ErrorType<void | WorkspaceDetectionsResponseOutput>,
>(
  submissionId: string,
  shelveId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useShelfDetectionsHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useShelfDetections<
  TData = Awaited<ReturnType<ReturnType<typeof useShelfDetectionsHook>>>,
  TError = ErrorType<void | WorkspaceDetectionsResponseOutput>,
>(
  submissionId: string,
  shelveId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useShelfDetectionsHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useShelfDetectionsQueryOptions(
    submissionId,
    shelveId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const usePatchShelfStatusHook = () => {
  const patchShelfStatus = useCustomAxiosInstance<ShelfStatusResponseOutput>();

  return useCallback(
    (
      submissionId: string,
      shelveId: string,
      shelfStatusBody: BodyType<ShelfStatusBody>
    ) => {
      return patchShelfStatus({
        url: `/api/submissions/${submissionId}/shelves/${shelveId}/status`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: shelfStatusBody,
      });
    },
    [patchShelfStatus]
  );
};

export const usePatchShelfStatusMutationOptions = <
  TError = ErrorType<void | ShelfStatusResponseOutput>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePatchShelfStatusHook>>>,
    TError,
    { submissionId: string; shelveId: string; data: BodyType<ShelfStatusBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof usePatchShelfStatusHook>>>,
  TError,
  { submissionId: string; shelveId: string; data: BodyType<ShelfStatusBody> },
  TContext
> => {
  const mutationKey = ['patchShelfStatus'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const patchShelfStatus = usePatchShelfStatusHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof usePatchShelfStatusHook>>>,
    { submissionId: string; shelveId: string; data: BodyType<ShelfStatusBody> }
  > = (props) => {
    const { submissionId, shelveId, data } = props ?? {};

    return patchShelfStatus(submissionId, shelveId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchShelfStatusMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof usePatchShelfStatusHook>>>
>;
export type PatchShelfStatusMutationBody = BodyType<ShelfStatusBody>;
export type PatchShelfStatusMutationError =
  ErrorType<void | ShelfStatusResponseOutput>;

export const usePatchShelfStatus = <
  TError = ErrorType<void | ShelfStatusResponseOutput>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof usePatchShelfStatusHook>>>,
      TError,
      {
        submissionId: string;
        shelveId: string;
        data: BodyType<ShelfStatusBody>;
      },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof usePatchShelfStatusHook>>>,
  TError,
  { submissionId: string; shelveId: string; data: BodyType<ShelfStatusBody> },
  TContext
> => {
  const mutationOptions = usePatchShelfStatusMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get predictions for a detection
 */
export const usePredictionsHook = () => {
  const predictions = useCustomAxiosInstance<PredictionsResponseOutput>();

  return useCallback(
    (params: PredictionsParams, signal?: AbortSignal) => {
      return predictions({
        url: `/api/detections/predictions`,
        method: 'GET',
        params,
        signal,
      });
    },
    [predictions]
  );
};

export const getPredictionsQueryKey = (params: PredictionsParams) => {
  return [`/api/detections/predictions`, ...(params ? [params] : [])] as const;
};

export const usePredictionsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionsHook>>>,
  TError = ErrorType<void | PredictionsResponseOutput>,
>(
  params: PredictionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof usePredictionsHook>>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPredictionsQueryKey(params);

  const predictions = usePredictionsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof usePredictionsHook>>>
  > = ({ signal }) => predictions(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof usePredictionsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PredictionsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof usePredictionsHook>>>
>;
export type PredictionsQueryError = ErrorType<void | PredictionsResponseOutput>;

export function usePredictions<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionsHook>>>,
  TError = ErrorType<void | PredictionsResponseOutput>,
>(
  params: PredictionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof usePredictionsHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof usePredictionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof usePredictionsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePredictions<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionsHook>>>,
  TError = ErrorType<void | PredictionsResponseOutput>,
>(
  params: PredictionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof usePredictionsHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof usePredictionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof usePredictionsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePredictions<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionsHook>>>,
  TError = ErrorType<void | PredictionsResponseOutput>,
>(
  params: PredictionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof usePredictionsHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get predictions for a detection
 */

export function usePredictions<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionsHook>>>,
  TError = ErrorType<void | PredictionsResponseOutput>,
>(
  params: PredictionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof usePredictionsHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = usePredictionsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a new detection
 */
export const useCreateDetectionHook = () => {
  const createDetection = useCustomAxiosInstance<DetectionResponseOutput>();

  return useCallback(
    (
      createDetectionBody: BodyType<CreateDetectionBody>,
      signal?: AbortSignal
    ) => {
      return createDetection({
        url: `/api/detections`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createDetectionBody,
        signal,
      });
    },
    [createDetection]
  );
};

export const useCreateDetectionMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateDetectionHook>>>,
    TError,
    { data: BodyType<CreateDetectionBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCreateDetectionHook>>>,
  TError,
  { data: BodyType<CreateDetectionBody> },
  TContext
> => {
  const mutationKey = ['createDetection'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const createDetection = useCreateDetectionHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCreateDetectionHook>>>,
    { data: BodyType<CreateDetectionBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createDetection(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDetectionMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useCreateDetectionHook>>>
>;
export type CreateDetectionMutationBody = BodyType<CreateDetectionBody>;
export type CreateDetectionMutationError = ErrorType<void>;

/**
 * @summary Create a new detection
 */
export const useCreateDetection = <
  TError = ErrorType<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useCreateDetectionHook>>>,
      TError,
      { data: BodyType<CreateDetectionBody> },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCreateDetectionHook>>>,
  TError,
  { data: BodyType<CreateDetectionBody> },
  TContext
> => {
  const mutationOptions = useCreateDetectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Update a detection
 */
export const usePatchDetectionHook = () => {
  const patchDetection = useCustomAxiosInstance<DetectionResponseOutput>();

  return useCallback(
    (detectionId: string, patchDetectionBody: BodyType<PatchDetectionBody>) => {
      return patchDetection({
        url: `/api/detections/${detectionId}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: patchDetectionBody,
      });
    },
    [patchDetection]
  );
};

export const usePatchDetectionMutationOptions = <
  TError = ErrorType<void | DetectionResponseOutput>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePatchDetectionHook>>>,
    TError,
    { detectionId: string; data: BodyType<PatchDetectionBody> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof usePatchDetectionHook>>>,
  TError,
  { detectionId: string; data: BodyType<PatchDetectionBody> },
  TContext
> => {
  const mutationKey = ['patchDetection'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const patchDetection = usePatchDetectionHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof usePatchDetectionHook>>>,
    { detectionId: string; data: BodyType<PatchDetectionBody> }
  > = (props) => {
    const { detectionId, data } = props ?? {};

    return patchDetection(detectionId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchDetectionMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof usePatchDetectionHook>>>
>;
export type PatchDetectionMutationBody = BodyType<PatchDetectionBody>;
export type PatchDetectionMutationError =
  ErrorType<void | DetectionResponseOutput>;

/**
 * @summary Update a detection
 */
export const usePatchDetection = <
  TError = ErrorType<void | DetectionResponseOutput>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof usePatchDetectionHook>>>,
      TError,
      { detectionId: string; data: BodyType<PatchDetectionBody> },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof usePatchDetectionHook>>>,
  TError,
  { detectionId: string; data: BodyType<PatchDetectionBody> },
  TContext
> => {
  const mutationOptions = usePatchDetectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Delete a detection
 */
export const useDeleteDetectionHook = () => {
  const deleteDetection =
    useCustomAxiosInstance<GenericSuccessResponseOutput>();

  return useCallback(
    (detectionId: string) => {
      return deleteDetection({
        url: `/api/detections/${detectionId}`,
        method: 'DELETE',
      });
    },
    [deleteDetection]
  );
};

export const useDeleteDetectionMutationOptions = <
  TError = ErrorType<void | GenericSuccessResponseOutput>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDeleteDetectionHook>>>,
    TError,
    { detectionId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useDeleteDetectionHook>>>,
  TError,
  { detectionId: string },
  TContext
> => {
  const mutationKey = ['deleteDetection'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const deleteDetection = useDeleteDetectionHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useDeleteDetectionHook>>>,
    { detectionId: string }
  > = (props) => {
    const { detectionId } = props ?? {};

    return deleteDetection(detectionId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteDetectionMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useDeleteDetectionHook>>>
>;

export type DeleteDetectionMutationError =
  ErrorType<void | GenericSuccessResponseOutput>;

/**
 * @summary Delete a detection
 */
export const useDeleteDetection = <
  TError = ErrorType<void | GenericSuccessResponseOutput>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useDeleteDetectionHook>>>,
      TError,
      { detectionId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useDeleteDetectionHook>>>,
  TError,
  { detectionId: string },
  TContext
> => {
  const mutationOptions = useDeleteDetectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
